var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01677 7.59415C0.90328 7.41445 0.846535 7.3246 0.81477 7.18602C0.79091 7.08192 0.79091 6.91775 0.81477 6.81366C0.846535 6.67507 0.90328 6.58522 1.01677 6.40552C1.95461 4.92054 4.74617 1.1665 9.00034 1.1665C13.2545 1.1665 16.0461 4.92054 16.9839 6.40552C17.0974 6.58522 17.1541 6.67507 17.1859 6.81366C17.2098 6.91775 17.2098 7.08192 17.1859 7.18602C17.1541 7.3246 17.0974 7.41445 16.9839 7.59415C16.0461 9.07914 13.2545 12.8332 9.00034 12.8332C4.74617 12.8332 1.95461 9.07914 1.01677 7.59415Z",
    stroke: "#ACB6C6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00034 9.49984C10.381 9.49984 11.5003 8.38055 11.5003 6.99984C11.5003 5.61913 10.381 4.49984 9.00034 4.49984C7.61962 4.49984 6.50034 5.61913 6.50034 6.99984C6.50034 8.38055 7.61962 9.49984 9.00034 9.49984Z",
    stroke: "#ACB6C6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalView);
export default __webpack_public_path__ + "static/media/totalView.257c67e3d7914f1cee6b2ef21899bf99.svg";
export { ForwardRef as ReactComponent };